/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentProfile } from '../../models/student-profile';

export interface StudentprofileIdSkilldGetProfileGet$Plain$Params {
  id: string;
  randomGuid?: string;
}

export function studentprofileIdSkilldGetProfileGet$Plain(http: HttpClient, rootUrl: string, params: StudentprofileIdSkilldGetProfileGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
  const rb = new RequestBuilder(rootUrl, studentprofileIdSkilldGetProfileGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('randomGuid', params.randomGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StudentProfile>;
    })
  );
}

studentprofileIdSkilldGetProfileGet$Plain.PATH = '/studentprofile/{id}/skilld/get-profile';
